// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__FuS8O"};